module.exports = __webpack_public_path__ + "static/img/cont3607.7856415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3607.jpg
// module id = /o2k
// module chunks = 0